/**
 * Instellingen (§2/§19): volume, dempen, en voortgang wissen (met bevestiging).
 */
import { useState } from 'react';
import { getVolume, isGedempt, zetVolume, zetGedempt, testToon } from '../audio';
import { useProgressStore } from '../store/progressStore';
import { t, type Taal } from '../i18n';

interface Props {
  taal: Taal;
  onTerug: () => void;
}

const GOUD = '#c9a86a';

export function Instellingen({ taal, onTerug }: Props) {
  const reset = useProgressStore((s) => s.resetVoortgang);
  const [volume, setVolume] = useState(getVolume());
  const [gedempt, setGedempt] = useState(isGedempt());
  const [bevestig, setBevestig] = useState(false);

  const wijzigVolume = (v: number) => { setVolume(v); zetVolume(v); };

  return (
    <div className="mandala-textuur flex h-full w-full flex-col bg-achtergrond text-slate-100">
      <div className="flex items-center justify-between border-b border-white/10 px-4 py-2">
        <h2 className="text-lg font-bold" style={{ fontFamily: 'Cinzel, serif', color: GOUD }}>{t('ui.instellingen', taal)}</h2>
        <button type="button" onClick={onTerug} className="rounded border border-white/15 px-3 py-1 text-sm hover:bg-white/5">← {t('ui.terug', taal)}</button>
      </div>

      <div className="mx-auto flex w-full max-w-md flex-col gap-6 p-6">
        {/* volume */}
        <div className="flex flex-col gap-2">
          <label className="flex items-center justify-between text-sm text-slate-300">
            <span>{t('ui.volume', taal)}</span>
            <span style={{ fontFamily: 'JetBrains Mono, monospace', color: GOUD }}>{Math.round(volume * 100)}%</span>
          </label>
          <input
            type="range" min={0} max={1} step={0.05} value={volume}
            onChange={(e) => wijzigVolume(parseFloat(e.target.value))}
            onMouseUp={() => testToon()} onTouchEnd={() => testToon()}
            className="w-full accent-amber-400"
          />
        </div>

        {/* dempen */}
        <label className="flex items-center justify-between text-sm text-slate-300">
          <span>{t('ui.dempen', taal)}</span>
          <input
            type="checkbox" checked={gedempt}
            onChange={(e) => { setGedempt(e.target.checked); zetGedempt(e.target.checked); }}
            className="h-5 w-5 accent-amber-400"
          />
        </label>

        {/* reset */}
        <div className="mt-4 border-t border-white/10 pt-4">
          {!bevestig ? (
            <button type="button" onClick={() => setBevestig(true)} className="rounded-lg border border-rose-400/40 px-4 py-2 text-sm text-rose-200 hover:bg-rose-400/10">
              {t('ui.reset', taal)}
            </button>
          ) : (
            <div className="flex flex-col gap-2">
              <p className="text-sm text-rose-200">{t('ui.resetBevestig', taal)}</p>
              <div className="flex gap-2">
                <button type="button" onClick={() => { reset(); setBevestig(false); }} className="rounded-lg bg-rose-500 px-4 py-2 text-sm font-semibold text-black">{t('ui.ja', taal)}</button>
                <button type="button" onClick={() => setBevestig(false)} className="rounded-lg border border-white/15 px-4 py-2 text-sm">{t('ui.annuleer', taal)}</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
